module.exports = __webpack_public_path__ + "img/ec2-alert.39ad9940.svg";